import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import StateTranslate from "../../Components/StateTranslate";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListAnnouncements(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [loading, setLoading] = useState(true);

  let query = useQuery();

  const [announcementsList, setAnnouncementsList] = useState();
  const [announcementsListTemp, setAnnouncementsListTemp] = useState();
  const [allAnnouncements, setAllAnnouncements] = useState([]);

  const [removableSession, setRemovableSession] = useState();

  useEffect(() => {
    setLoading(false);

    Repo.getAnnouncementsOperator(apiToken)
      .then((response) => {
        setAnnouncementsListTemp(response.data);
        setAllAnnouncements(response.data);
        const uniqueServizi = [
          ...new Map(
            response.data
              .filter((x) => x.service)
              .map((x) => [x.service.id, x.service]),
          ).values(),
        ].map((s) => ({ value: s.id, label: s.name, name: s.name }));
        setServizi(uniqueServizi);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const filterSessions = (e) => {
    if (e) {
      setServizioTemp(e.name);
      setAnnouncementsListTemp(
        allAnnouncements.filter((x) => x.service && x.service.id === e.value)
      );
    } else {
      setServizioTemp();
      setAnnouncementsListTemp(allAnnouncements);
    }
  };

  const deleteSessione = () => {
    Repo.deleteSession(apiToken, removableSession)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
          // setAnnouncementsListTemp(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sessions = () => {
    return (
      <>
        {announcementsListTemp && announcementsListTemp.length > 0 ? (
          <>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Intervento</th>
                  <th scope="col">Categoria</th>
                  {announcementsListTemp.some((x) => x.expirationDate) && (
                    <th scope="col">Scadenza ultima iscrizione</th>
                  )}
                  <th scope="col">Stato</th>
                  <th scope="col" style={{ minWidth: "130px" }}></th>
                </tr>
              </thead>
              <tbody>
                {announcementsListTemp &&
                  announcementsListTemp.length > 0 &&
                  announcementsListTemp.map((x, index) => (
                    <tr key={index}>
                      <td scope="row">{x.name}</td>
                      <td>{x.service.name}</td>
                      {announcementsListTemp.some((x) => x.expirationDate) ? (
                        <td>
                          <span className="ml-5">
                            {x.expirationDate ? x.expirationDate : "-"}
                          </span>
                        </td>
                      ) : null}
                      <td>
                        <StateTranslate text={x.state} trasform="U" />
                      </td>
                      <td className="text-right">
                        <Link
                          to={
                            "/lista_interventi/dettaglio_intervento?id=" + x.id
                          }
                        >
                          {props.isExecutive && x.service.tipoServizio === 2 ? (
                            <button
                              className="btn btn-outline-primary p-1"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Dettaglio"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-search`} />
                              </svg>
                            </button>
                          ) : !props.isExecutive ? (
                            <button
                              className="btn btn-outline-primary p-1"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Dettaglio"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-search`} />
                              </svg>
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-primary p-1 border"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Ruolo non autorizzato"
                              disabled={true}
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-search`} />
                              </svg>
                            </button>
                          )}
                        </Link>
                        {!props.isDelegate && !props.isExecutive && (
                          <button
                            className="btn btn-outline-danger p-1 ml-1"
                            type="button"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Elimina"
                            onClick={() => {
                              toggleModal(!isOpen);
                              setRemovableSession(x.id);
                            }}
                          >
                            <svg className="icon icon-danger">
                              <use href={`${iconSprite}#it-delete`} />
                            </svg>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {announcementsListTemp && (
              <Pagination
                items={announcementsListTemp}
                setCurrentItems={setAnnouncementsList}
                itemsPerPage={15}
              ></Pagination>
            )}
          </>
        ) : (
          <div>Non sono presenti interventi</div>
        )}
      </>
    );
  };

  return (
    <>
      <div>
        <h1>Lista interventi</h1>

        <div className="row mt-4 mb-5 ">
          <div className="col-lg-10 clearfix">
            <div className="bootstrap-select-wrapper col-6">
              <Select
                aria-label="Servizio"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="servizio"
                id="servizio"
                options={servizi}
                onChange={(e) => filterSessions(e)}
                isClearable
                isSearchable
                placeholder={
                  servizioTemp && servizioTemp
                    ? servizioTemp
                    : "Seleziona categoria"
                }
              />
            </div>
          </div>
          {!props.isDelegate && !props.isExecutive && (
            <div className="col-lg-2 clearfix">
              <Link to={"/lista_interventi/nuovo_intervento"}>
                <button
                  type="button"
                  className="btn btn-outline-primary float-right p-2"
                >
                  <svg className="icon icon-primary">
                    <use href={`${iconSprite}#it-plus-circle`} />
                  </svg>{" "}
                  <span className="align-middle">Nuovo intervento</span>
                </button>
              </Link>
            </div>
          )}
        </div>
        {sessions()}
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Elimina intervento"
        body="Confermi di voler eliminare questo intervento?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteSessione()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}
export default ListAnnouncements;
